import React, { useContext, useState } from 'react'
import { dataContext, localestr } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import Panel from '../cmp/Panel.js';
//import EditImg from '../cmp/EditImg.js';

function CatMenuGrpEdit({ data, actions }) {
  let wndData = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabClose = actions.tabClose
  const context = useContext(dataContext)
  const saveData = context.saveData
  const msg = context.msg
  const loaddata = context.loaddata
  const langs = context.data['sysConst']['langs'] || []
  const setValue = (name, data) => {
    let newData = { ...wndData }
    newData.changed = true
    if (data === '') newData[name] = null
    else newData[name] = data
    setWndData(newData)
    
  }
  const update = (d) => {
    let newData = { ...wndData, ...d.data, changed: false }
    setWndData(newData)
    //tabClose()
  }

  const generateTranslations = () => {
    if (!langs || langs.length === 0 || langs.every(l => Number(l.is_used) === 0)) {
      msg(localestr('Оберіть мову для перекладу в налаштуванням онлайн меню'), localestr('Помилка'), [{
        caption: 'OK',
        action: () => { }
      }]);
      return;
    }

    const selectedLangs = langs.filter(l => Number(l.is_used) === 1).map(i => i.code);
    let newData = { ...wndData, changed: true };
    if (!wndData.id) {

      let items = [{
        type: 3,
        data: [{
          id: 0,
          name: wndData?.name ?? '',
          description: wndData?.note || null,
        }],
        fields: ['name', 'description']
      }];

      loaddata(
        `action=translation&data=${JSON.stringify({
          langs: selectedLangs,
          items,
          new: true
        })}`,
        undefined,
        (d) => processTranslationData(d, newData)
      );
    } else {

      loaddata(
        `action=translation&data=${JSON.stringify({
          langs: selectedLangs,
          entities: [{ type: 3, ids: [wndData.id] }]
        })}`,
        undefined,
        (d) => processTranslationData(d, newData)
      );
    }
  };

  const processTranslationData = (responseData, newData) => {
    newData.translations = {
      en: { name: '', description: '' },
      de: { name: '', description: '' },
      it: { name: '', description: '' },
      hu: { name: '', description: '' }
    };

    if (responseData.data['3']) {
      for (const key in responseData.data['3']) {
        const product = responseData.data['3'][key];
        for (const lang in product) {
          if (newData.translations[lang]) {
            newData.translations[lang].name = product[lang]?.name || '';
            newData.translations[lang].description = product[lang]?.description || '';
            newData.translations[lang].type = 3;
          }
        }
      }
    }

    setWndData(newData, true);
  };

  const saveValue = (action = () => { }) => {
    if (!wndData.changed) { action({}); return }
    let errmsg = ''
    const name = (wndData.name || '').substring(0, 50)
    const colour = wndData.colour ? wndData.colour.src : null
    const sorting = wndData.sorting || 'NULL'
    const big_img = (wndData.big_img || 'NULL').replace(/\+/g, ' ')
    const parent = wndData.parent || { id: null, name: null }
    const translations = wndData?.translations ?? {};
    const start = wndData.start ?? 'NULL';
    const finish = wndData.finish ?? 'NULL';
    const note = wndData.note ?? 'NULL';

    if (name === null || name === '') errmsg = localestr("Не заповнено ім'я")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      let data = { name, colour, big_img, sorting, start, finish, note, parent, translations: { ...translations } };
      console.log(data, 'saveValue')
      if (wndData.id) {
        data.id = wndData.id
        let newData = { status: 'mod', key: 'CatMenuGrp', data }
        saveData(newData, action)
      } else {
        let newData = { status: 'add', key: 'CatMenuGrp', data }
        saveData(newData, action)
      }
    }

  }

  const setTranslationValue = (name, code, data) => {
    let newData = { ...wndData, changed: true }
    // console.log(name, code, data);
    let translations = wndData.translations || {}
    if (!translations[code]) translations[code] = { name: "", description: "", type: 3 }
    if (data === '') translations[code][name] = null
    else translations[code][name] = data
    console.log(translations);
    newData['translations'] = translations
    setWndData(newData, true)
  }

  const [activeTab, setActiveTab] = useState(langs.find(l => l.code !== 'uk')?.code || '');
  let langs_cont = ''
  if (langs.length > 0) {
    langs_cont = <Panel caption={localestr('Переклади')} width={792} open={wndData.p_lang === undefined ? false : wndData.p_lang} setOpen={d => setWndData({ ...wndData, p_lang: d })}>
      <div style={{ display: 'flex', gap: '2px' }}>
        {langs.map(item => item.code !== 'uk' ? (
          <button key={item.code} onClick={() => setActiveTab(item.code)}
            className={`tabbuton ${activeTab === item.code && "active"}`}
            style={{ maxWidth: "150px", padding: "0px" }}>{item.name}</button>
        ) : null
        )}
      </div>
      {langs.map(item =>
        item.code !== 'uk' && item.code === activeTab ? (
          <div key={item.id} style={{ margin: '3px 0', display: 'inherit' }}>
            <div style={{ margin: '3px 0', display: 'inherit', flexDirection: 'column', width: '492px', maxWidth: '1300px', flexGrow: 492 }}>
              {window.innerWidth < 366 ? (
                <>
                <EditCtrl Capt={localestr('Назва')} Value={wndData?.translations?.[item.code]?.name || ""} typeVal={'text'}
                  setVal={(d) => { setTranslationValue('name', item.code, d) }} width1='50' width2='100' />
                <EditCtrl Capt={localestr('Повідомлення під секцією')} Value={wndData?.translations?.[item.code]?.description || ""} typeVal={'text'} 
                  setVal={(d) => { setTranslationValue('description', item.code, d) }} width1='200' width2='137' />
                </>
              ) : (
                <>
                <EditCtrl Capt={localestr('Назва')} Value={wndData?.translations?.[item.code]?.name || ""} typeVal={'text'}
                  setVal={(d) => { setTranslationValue('name', item.code, d) }} width1='92' width2='404' />
                <EditCtrl Capt={localestr('Повідомлення під секцією')} Value={wndData?.translations?.[item.code]?.description || ""} typeVal={'text'} 
                  setVal={(d) => { setTranslationValue('description', item.code, d) }} width1='200' width2='137' />
                </>
              )}

            </div>
          </div>
        ) : null
      )}

      {window.innerWidth < 366 ? (
        <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', flexGrow: '100000' }}>
          <div style={{ width: '250px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'}
            onClick={() => generateTranslations()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>
              {localestr('Згенерувати автопереклад')}</div></div>
        </div>
      ) : (
        <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
          <div style={{ width: '250px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'}
            onClick={() => generateTranslations()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>
              {localestr('Згенерувати автопереклад')}</div></div>
        </div>
      )}

    </Panel>
  }

  if (window.innerWidth < 366) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 10px)' }}>
        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='18' width2='10' disabled={true} />
          <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='47' width2='80' />
        </div>
        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <EditCtrl Capt={localestr('Порядок сортування')} Value={wndData.sorting} typeVal={'number'} setVal={(d) => { setValue('sorting', d) }} width1='95' width2='1' />
          <EditCtrl Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldMenuGrp'} setVal={(d) => { setValue('parent', d) }} width1='44' width2='20' />
        </div>
        {langs_cont}
        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <div style={{ width: '60px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(tabClose) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(update) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
        </div>
      </div>
    )
  }
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', alignSelf: 'flex-start', flexGrow: '10000' }}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='18' width2='50' disabled={true} />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='47' width2='214' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Порядок сортування')} Value={wndData.sorting} typeVal={'number'} setVal={(d) => { setValue('sorting', d) }} width1='155' width2='32' />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldMenuGrp'} setVal={(d) => { setValue('parent', d) }} width1='44' width2='98' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Обмежити секцію по часу з')} Value={wndData.start} typeVal={'time'} setVal={(d) => { setValue('start', d) }} width1='210' width2='60' />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={'по'} typeVal={'time'} Value={wndData.finish} setVal={(d) => { setValue('finish', d) }} width1='25' width2='75' />
        <div style={{ width: '95px', display: 'inline-block', flexGrow: 10000 }}></div>
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Повідомлення під секцією')} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='200' width2='137' />
      </div>
      {langs_cont}
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <div style={{ width: '60px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(tabClose) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
        <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(update) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
      </div>
    </div>
  )

}

export default CatMenuGrpEdit